import React, { useContext, useState, useEffect } from "react";
import sad from "../../../../assets/images/moods/Sad.png";
import unhappy from "../../../../assets/images/moods/Unhappy.png";
import okay from "../../../../assets/images/moods/Neutral.png";
import happy from "../../../../assets/images/moods/Happy.png";
import excited from "../../../../assets/images/moods/Excited.png";
import { UserContext } from "../../../../storage/contexts/UserContext";

const MoodCaptureForm = ({ selectedMood, onChange }) => {
  const { profile } = useContext(UserContext);
  const [isMobile, setIsMobile] = useState(false);

  const moodData = [
    { moodId: 0, moodImg: profile?.sadMindmoji || sad, moodName: "sad" },
    {
      moodId: 1,
      moodImg: profile?.unhappyMindmoji || unhappy,
      moodName: "unhappy",
    },
    { moodId: 2, moodImg: profile?.okayMindmoji || okay, moodName: "okay" },
    { moodId: 3, moodImg: profile?.happyMindmoji || happy, moodName: "happy" },
    {
      moodId: 4,
      moodImg: profile?.elatedMindmoji || excited,
      moodName: "elated",
    },
  ];

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleMoodChange = (moodId) => {
    if (onChange) {
      onChange(moodId);
    }
  };

  return (
    <div className="flex flex-col items-center py-5">
      <h4 className="text-2xl font-semibold text-center mb-20">
        How are you feeling?
      </h4>

      {isMobile ? (
        <div className="w-full max-w-md mb-8">
          {/* First 4 moods in 2-column grid */}
          <div className="grid grid-cols-2 gap-4">
            {moodData.slice(0, 4).map((item) => (
              <div
                key={item.moodId}
                className={`flex flex-col items-center justify-center transition-transform duration-300 ease-in-out ${
                  selectedMood === item.moodId
                    ? "scale-90 -translate-y-4"
                    : "scale-75 translate-y-0"
                }`}
              >
                <input
                  id={`${item.moodName}MoodOption`}
                  type="radio"
                  name="moodOptions"
                  value={item.moodName}
                  checked={selectedMood === item.moodId}
                  onChange={() => handleMoodChange(item.moodId)}
                  className="hidden"
                />
                <label
                  htmlFor={`${item.moodName}MoodOption`}
                  className="cursor-pointer flex justify-center"
                >
                  <img
                    src={item.moodImg}
                    className="h-32 w-32 object-contain"
                    alt={item.moodName}
                  />
                </label>
              </div>
            ))}
          </div>
          {/* Last mood centered */}
          <div className="flex justify-center mt-4">
            {moodData.slice(-1).map((item) => (
              <div
                key={item.moodId}
                className={`flex flex-col items-center justify-center transition-transform duration-300 ease-in-out ${
                  selectedMood === item.moodId
                    ? "scale-90 -translate-y-4"
                    : "scale-75 translate-y-0"
                }`}
              >
                <input
                  id={`${item.moodName}MoodOption`}
                  type="radio"
                  name="moodOptions"
                  value={item.moodName}
                  checked={selectedMood === item.moodId}
                  onChange={() => handleMoodChange(item.moodId)}
                  className="hidden"
                />
                <label
                  htmlFor={`${item.moodName}MoodOption`}
                  className="cursor-pointer flex justify-center"
                >
                  <img
                    src={item.moodImg}
                    className="h-32 w-32 object-contain"
                    alt={item.moodName}
                  />
                </label>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-5 gap-6 mb-8">
          {moodData.map((item) => (
            <div
              key={item.moodId}
              className={`flex flex-col items-center justify-center transition-transform duration-300 ease-in-out ${
                selectedMood === item.moodId
                  ? "scale-125 -translate-y-4"
                  : "scale-100 translate-y-0"
              }`}
            >
              <input
                id={`${item.moodName}MoodOption`}
                type="radio"
                name="moodOptions"
                value={item.moodName}
                checked={selectedMood === item.moodId}
                onChange={() => handleMoodChange(item.moodId)}
                className="hidden"
              />
              <label
                htmlFor={`${item.moodName}MoodOption`}
                className="cursor-pointer flex justify-center"
              >
                <img
                  src={item.moodImg}
                  className="h-32 w-32 object-contain"
                  alt={item.moodName}
                />
              </label>
            </div>
          ))}
        </div>
      )}

      <h4 className="text-lg mt-4 capitalize text-gray-800 text-center">
        {moodData[selectedMood]?.moodName || ""}
      </h4>
    </div>
  );
};

export default MoodCaptureForm;
